export const environment = {
    production: true
}
